module.exports = __webpack_public_path__ + "static/Lato-Italic-90d8ae9e97ee1e2e749d4eb1d3f8bb33.woff";